import React from 'react';
import {
  DSTruncatedTooltipText,
  TooltipTextProvider,
} from '@elliemae/ds-truncated-tooltip-text';
import { PopperPositions as Positions } from '@elliemae/ds-popper';
import {
  ApplyExceptionButton,
  ManageExceptionButton,
  canManageException,
  canShowApplyException,
} from '../../EligibilityException';
import {
  StyledIneligibleProgramLinks,
  StyledIneligibleRow,
  StyledIneligibleReason,
} from '../styled';

export const getIneligibleGridColumns = () => [
  {
    accessor: 'program',
    Header: 'Program Name',
    minWidth: '60px',
    width: '35%',
    Cell: ({ row, onClickProgramName }) => {
      const { program } = row.original;
      return (
        <StyledIneligibleRow>
          <TooltipTextProvider>
            <DSTruncatedTooltipText
              value={
                <StyledIneligibleProgramLinks
                  onClick={() => onClickProgramName(row.original)}
                >
                  {program}
                </StyledIneligibleProgramLinks>
              }
              tooltipPlacement={Positions.TOP}
            />
          </TooltipTextProvider>
        </StyledIneligibleRow>
      );
    },
  },
  {
    Header: 'Ineligibility Reason',
    width: '45%',
    Cell: ({ row }) => {
      // Render each reason on its own line.
      const reasons = (row.original.notes ?? '')
        .split('|')
        .map((reason) => reason.trim())
        .filter(Boolean);
      return (
        <StyledIneligibleReason>
          {reasons.map((reason, index) => (
            <div key={`${index}-${reason}`}>{reason}</div>
          ))}
        </StyledIneligibleReason>
      );
    },
  },
  {
    // Manage when a saved exception exists, otherwise Apply.
    Header: '',
    width: '20%',
    Cell: ({ row, onApplyException, onManageException }) => {
      if (canManageException(row.original)) {
        return (
          <ManageExceptionButton
            onClick={() => onManageException(row.original)}
          />
        );
      }
      return canShowApplyException(row.original) ? (
        <ApplyExceptionButton onClick={() => onApplyException(row.original)} />
      ) : null;
    },
  },
];
